export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.48 2.2c-.42-.73-.94-1.36-1.78-1.78C16.86 0 15.71 0 13.51 0H6.39C4.19 0 3.04 0 2.2.42 1.36.84.84 1.36.42 2.2 0 3.04 0 4.19 0 6.39v7.23c0 2.2 0 3.35.42 4.19.42.73.94 1.36 1.78 1.78.84.42 1.99.42 4.19.42h7.23c2.2 0 3.35 0 4.19-.42.73-.42 1.36-.94 1.78-1.78s.42-1.99.42-4.19V6.39c-.1-2.3-.1-3.35-.52-4.19Zm-4.03 6.47c-.1 0-.21.02-.31.02-1.19 0-2.24-.61-2.85-1.54v5.24c0 2.14-1.73 3.87-3.87 3.87s-3.87-1.73-3.87-3.87a3.867 3.867 0 0 1 4.11-3.86v1.91c-.08 0-.16-.02-.24-.02-1.09 0-1.98.88-1.98 1.98s.88 1.98 1.98 1.98 2.06-.86 2.06-1.95l.02-8.9h1.82a3.407 3.407 0 0 0 3.13 3.04v2.12Z"/>
  `,
  title: 'Tiktok',
  viewBox: '0 0 21 20',
};
